/**
 * PineForge.AI — Launch offer end date.
 *
 * Stored as a single frozen ISO-8601 UTC timestamp so the countdown
 * NEVER resets on refresh and is identical for every visitor.
 *
 * Set on 2026-07-04 UTC. Launch offer runs for 21 days
 * → ends 2026-07-25 23:59:59 UTC.
 *
 * When the countdown reaches zero, the pricing UI stays visible but the
 * "Launch offer ends in …" strip switches to "Launch offer has ended.".
 */

export const LAUNCH_END_ISO = "2026-07-25T23:59:59.000Z";

/**
 * Returns the launch end date as a JS `Date`.
 * Callers should use `new Date()` for "now" and compare.
 */
export function launchEndDate() {
  return new Date(LAUNCH_END_ISO);
}
